import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid2';
import { useErrorBoundary } from 'react-error-boundary';
import { Box, FormControl, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import YtdReport from '../../../types/reports/ytdReport';
import LegislativeRaceTable from '../../Reports/components/LegislativeRaceTable';

interface Props {
    cityCode?: number;
    reports?: YtdReport[]
}

const TownFilersReports = (props: Props): JSX.Element => {

    const { showBoundary } = useErrorBoundary();
    const dropDownYears = Array.from(new Array(10), (val, index) => new Date().getFullYear()%2===0?new Date().getFullYear()- index*2: new Date().getFullYear()-1 - index*2);
    const [reportYear, setReportYear] = useState(()=>{
        if(new Date().getFullYear()%2===0){
            return new Date().getMonth()===0?new Date().getFullYear()-2: new Date().getFullYear();
        }
            return new Date().getFullYear()-1;
        });
    const [reports, setReports] = useState<YtdReport[]>();

    useEffect(() => {
        setReports(props.reports);
    }, [props.reports])

    const updateReporYear = (event: any) => {
        getTownReports(event.target.value);
    };

    const getTownReports = async (reportYear: number) => {

        try {
            await fetch(`${process.env.REACT_APP_API_BASE_URL}/municipality/byCode/${props.cityCode}/${reportYear}`)
                .then(result => {
                    if (!result.ok) {
                        showBoundary(new Error('Failed to get the town filers reports.'));
                    }
                    return result.json();
                })
                .then(result => {
                    setReports(result.filersReports);
                });
        } catch (error) {
            console.error('Uncaught Error:', error);
        }
    }


    return (
        <Box marginTop={3} marginBottom={4}>
            <Box marginBottom={4}>
                <Typography
                    variant="h6"
                    sx={{
                        textTransform: 'uppercase',
                    }}
                    fontWeight={700}
                    data-aos={'fade-up'}
                    gutterBottom
                    color={'secondary'}
                    align={'center'}
                >
                    RECENT ELECTION RACES
                </Typography>
            </Box>
            <Grid container spacing={4}>
                <Grid size={{ xs: 12, md: 10 }}>
                    <FormControl sx={{ m: 1, minWidth: 150 }} size="small">
                        <InputLabel id='race-year'>Race Year</InputLabel>
                        <Select
                            labelId='race-year'
                            label = "Race Year"
                            aria-label='Race Year'
                            aria-labelledby='race-year'
                            sx={{ fontSize: 'smaller' }}
                            defaultValue={reportYear}
                            onChange={updateReporYear}
                        >
                            {
                                dropDownYears.map((year) =>
                                    <MenuItem value={year} key={year} >{year}</MenuItem>
                                )
                            }
                        </Select>
                    </FormControl>
                </Grid>
                <Grid size={12} marginTop={1}>
                    <LegislativeRaceTable reports={reports}></LegislativeRaceTable>
                </Grid>
            </Grid>
        </Box>
    )

}

export default TownFilersReports;